import React, { Component } from 'react';
import { styles } from './JsonViewer.css';

const JsonViewer = (props) => {
    return props.init.verbose ? <div className="code">{JSON.stringify(props.data, 0, 2)}</div> : null ;
  };
  
export default JsonViewer;
  